const NotFound = () => {
    return (
        <>
            <h2>FOUR O&apos;FOUR</h2>
            <p>Looks like you found something that doesn&apos;t exist!</p>
        </>
    );
};

export default NotFound;
